module.exports = __webpack_public_path__ + "assets/img/ds9.1fba0149.jpg";